import { render, staticRenderFns } from "./M_permitConfig.vue?vue&type=template&id=e31c1db2&scoped=true&"
import script from "./M_permitConfig.vue?vue&type=script&lang=js&"
export * from "./M_permitConfig.vue?vue&type=script&lang=js&"
import style0 from "./M_permitConfig.vue?vue&type=style&index=0&id=e31c1db2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31c1db2",
  null
  
)

export default component.exports